import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { getPendingPbxSwitch, omitPendingPbxSwitch } from './pbxSwitchState'
import { usePbxSwitchExecutor } from './usePbxSwitchExecutor'

export const PendingPbxSwitchListener = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { currentPbx, executePbxSwitch } = usePbxSwitchExecutor()

  useEffect(() => {
    const pendingPbxSwitch = getPendingPbxSwitch(location.state)
    if (!pendingPbxSwitch) return

    navigate(
      {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
      },
      {
        replace: true,
        state: omitPendingPbxSwitch(location.state),
      },
    )

    if (currentPbx?.id === pendingPbxSwitch.id) return

    executePbxSwitch(pendingPbxSwitch)
  }, [
    currentPbx?.id,
    executePbxSwitch,
    location.hash,
    location.pathname,
    location.search,
    location.state,
    navigate,
  ])

  return null
}
